import {
  chakra as ChakraUIChakra,
  type HtmlProp,
  useBreakpointValue as ChakraUseBreakpointValue,
  useDisclosure as ChakraUseDisclosure,
} from '@chakra-ui/react';

export const chakra = ChakraUIChakra;
export const useDisclosure = ChakraUseDisclosure;
export const useBreakpointValue = ChakraUseBreakpointValue;
export type Color = HtmlProp;

export interface SelectionDetails {
  value: string[];
  itemValue: string;
}
